/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Management_DescriptionInputs */

const en_inventory_management_description = /** @type {(inputs: Inventory_Management_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage products, cargos, and warehouse locations`)
};

const es_inventory_management_description = /** @type {(inputs: Inventory_Management_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra productos, cargas y ubicaciones de almacen`)
};

/**
* | output |
* | --- |
* | "Manage products, cargos, and warehouse locations" |
*
* @param {Inventory_Management_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_management_description = /** @type {((inputs?: Inventory_Management_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Management_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_management_description(inputs)
	return es_inventory_management_description(inputs)
});